/**
 * Boolean mapper for not required fields
 * @param {Object} data - content data
 * @return {Boolean|null} - normalized data
 */
export default data => typeof data === 'boolean' ? `${data}` : null
